import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavService} from "../../../../../_services/_nav.service";
import {RotativoUC} from "../../../../../_models/rotativo-uc";
import {RxStompService} from "@stomp/ng2-stompjs";
import {
  SolicitudesUCErroresIntegracionesService
} from "../../../../../_services/solicitudes-ucerrores-integraciones.service";
import {ExcelAvance} from "../../../../../_models/excel-avance";
import {AutenticacionService} from "../../../../../_services/autenticacion.service";
import {UtilitiesService} from "../../../../../utils/utilities.service";
import {Message} from "@stomp/stompjs";
import {firstValueFrom, Subscription} from "rxjs";
import {GarantiasIdoneasTipoProductor} from "../../../../../_models/garantias-idoneas-tipo-producto";
import {ConfirmationService} from "primeng/api";
import {SolicitudUnidadCreditoService} from "../../../../../_services/solicitud-unidad-credito.service";

@Component({
  selector: 'app-widget-tershi',
  templateUrl: './widget-tershi.component.html',
  styleUrls: ['./widget-tershi.component.css']
})
export class WidgetTershiComponent implements OnInit, OnDestroy {
  contador = 0;
  showModalSolicitudes = false;
  listSolicitudes: RotativoUC[] = [];
  columnas: any[] = [];
  cargandoTabla = false;

  excelAvance: ExcelAvance;
  modalVerificacion = {verificando: false, estActual: null, error: false, individual: false};
  private topSubscription: Subscription;

  filtroLazy: {
    cantidad: number,
    pagina: number
  };
  page = '0';
  rowsPerPage = 10;
  loading = false;

  constructor(private navServicio: NavService,
              private rxStompService: RxStompService,
              private rotativoPendienteService: SolicitudesUCErroresIntegracionesService,
              private authService: AutenticacionService,
              public utilitiesService: UtilitiesService,
              private confirmacionServicio: ConfirmationService,
              private solUcService: SolicitudUnidadCreditoService,) { }

  ngOnInit() {
    this.columnas = [
      { field: 'fechaEjecucion', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_FECHAEJECUCION' ), sort: true },
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NUMERODOCUMENTO' ) },
      { field: 'errorServicio', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_ERRORSERVICIO' ) },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ) }
    ];
    this.conectarSocket();
    this.cargarContador();
  }

  visualizarIntegracionesFallidas() {
    const a = Object.assign({}, this.filtroLazy);
    this.page = '0';
    a.pagina = Number(this.page);
    a.cantidad = this.rowsPerPage;

    this.showModalSolicitudes = true;
    this.cargandoTabla = true;
    this.rotativoPendienteService.listado(a).subscribe(res => {
      if (res && res.content) {
        this.listSolicitudes = res.content;
      }
      this.cargandoTabla = false;
    }, error => {
      this.cargandoTabla = false;
      this.mensajeError();
    })
  }

  relanzar(row: RotativoUC) {
    this.cargandoTabla = true;
    this.modalVerificacion.estActual = 'INIT';
    this.modalVerificacion.verificando = true;
    this.modalVerificacion.individual = true;
    this.rotativoPendienteService.lanzarIndividual(this.authService.obtenerIdUsuarioLogueado(), row.idSolicitudUnidadCredito).subscribe(res => {
      this.cargandoTabla = false;
      if (res.error && !this.mostrarErrorEnModal(row, res.mensaje)) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: res.mensaje
        });
        this.modalVerificacion.estActual = null;
        this.cerrarVerificacion(true);
      } else {
        this.modalVerificacion.estActual = 'FINVER';
        if (res.error) {
          this.excelAvance = {} as ExcelAvance;
          this.excelAvance.errores = [];
          this.excelAvance.errores.push(res.mensaje);
          this.modalVerificacion.error = true;
        } else {
          this.mensajeExitoso();
          this.cargarContador();
          this.visualizarIntegracionesFallidas();
        }
      }
    })
  }

  eliminar(row: RotativoUC) {
    this.confirmacionServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'eliminar-rotativo-widget',
      accept: () => {
        this.cargandoTabla = true;
        this.rotativoPendienteService.eliminar(this.authService.obtenerIdUsuarioLogueado(), row.idSolicitudUnidadCredito).subscribe(res => {
          this.cargandoTabla = false;
          if (res && res.error) {
            this.navServicio.setMesage(0, {
              severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
              detail: res.mensaje
            });
          } else {
            this.mensajeExitoso();
          }
          this.cargarContador();
          this.visualizarIntegracionesFallidas();
        }, error => {
          this.mensajeError();
        })

      }
    } );
  }

  enviarIntegraciones() {
    this.cargandoTabla = true;
    this.rotativoPendienteService.lanzarTodos(this.authService.obtenerIdUsuarioLogueado()).subscribe(data => {
      this.excelAvance = data;
      this.modalVerificacion.estActual = 'INIT';
      this.modalVerificacion.verificando = true;
      this.cargandoTabla = false;
    }, err => {
      this.cargandoTabla = false;
      this.mensajeError();
    });
  }

  async cerrarVerificacion(individual: boolean = false) {
    this.modalVerificacion.verificando = false;
    if (!individual) {
      this.showModalSolicitudes = false;
    } else {
      this.modalVerificacion.individual = false;
    }
    this.modalVerificacion.error = false;
    this.excelAvance = null;
    this.cargandoTabla = true;
    await this.cargarContador();
    this.cargandoTabla = false;
    if (individual) {
      this.visualizarIntegracionesFallidas();
    }
  }

  async cargarContador() {
    this.loading = true;
    const pendientes = await firstValueFrom(this.solUcService.countPendienteActualizarCore());
    this.contador = pendientes;
    this.rowsPerPage = !this.contador || this.contador == 0 ? 10 : this.contador;
    this.loading = false;
  }

  conectarSocket() {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
    }
    this.topSubscription = this.rxStompService.watch('/topic/pendienteRotativo.' + this.authService.obtenerIdUsuarioLogueado()).subscribe(async (message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
        }
      }
    });
  }

  mostrarErrorEnModal(data: {[key:string]: any}, mensaje: string) {
    const simbolos = ['{', '}', '@', '"'];
    const contieneSimbolo = simbolos.some(simbolo => mensaje.includes(simbolo));

    const contienePunto = mensaje.includes('.') && mensaje[mensaje.length - 1] !== '.';

    const contieneNumero = /\d/.test(mensaje);

    const mismoErrorAnterior = mensaje === data.errorIntegracion;

    return contieneSimbolo || contienePunto || contieneNumero || mismoErrorAnterior;
  }

  mensajeExitoso() {
    this.navServicio.setMesage(0, {
      severity: "success",
      summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
      detail: this.navServicio.buscarMensaje("MSG_EXITOSERVICIO"),
    });
  }

  mensajeError() {
    this.navServicio.setMesage(0,
      {
        severity: 'error',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
      });
  }

  ngOnDestroy(): void {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
    }
  }
}
